"use client";

import React from "react";
import { Bookmark, MapPin, Phone, Share2, Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutSelcukluCafe() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="168152" id="tedavilerimiz-giriş" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden bg-background py-24 !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/image_8pusv98t.jpg)] !opacity-[1]">
      {}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-background via-secondary to-background bg-cover bg-fixed bg-center" />

      {}
      <div className="absolute inset-0 z-10 bg-background/10" />

      {}
      <div ref={ref} className={`relative z-20 mx-auto flex w-full max-w-4xl flex-col items-center px-4 text-center transition-all duration-[800ms] ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
        <h1 className="mb-6 font-serif text-5xl tracking-tight text-foreground md:text-7xl lg:text-8xl">
          Tedavilerimiz
        </h1>

        <div className="mb-10 flex flex-wrap items-center justify-center gap-4 text-lg text-foreground/80 md:gap-6">
          <div className="flex items-center gap-1.5">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => <Star key={i} data-index={i} className="size-5 fill-primary text-primary" />)}
            </div>
            <span className="font-medium text-foreground">5.0</span>
          </div>

          <div className="h-1.5 w-1.5 rounded-full bg-primary/40" />

          <span className="font-medium tracking-wide text-foreground/70">Premium Klinik</span>

          <div className="h-1.5 w-1.5 rounded-full bg-primary/40" />

          <Badge className="border-none bg-primary px-3 py-1 text-sm font-medium text-primary-foreground hover:bg-primary/90 rounded-sm">
            Kayseri
          </Badge>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4">
          

          

          

          
        </div>
      </div>
    </section>;
}